var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortableTable',{attrs:{"rows":_vm.statusRows,"headers":_vm.statusHeaders,"table-actions":false,"row-actions":false,"key-field":"key","default-sort-by":"state"}})}
var staticRenderFns = []

export { render, staticRenderFns }